import { CardDetailsInput, GetPlanOutput, PublishState } from './graphql/api';
import AvatarEditor from 'react-avatar-editor';
import { ReactElement } from 'react';

export type GiideRouteParams = {
  id: string;
};

export interface GiidePublishStateObj {
  [key: string]: boolean;
}

export type imageDimensions = {
  width: number;
  height: number;
};

export type SettingsCardDetails = {
  cardColor: string;
  cardShade: string;
  thumbnailImg: string;
  thumbnailCustomName: string;
  thumbnailCustomPath: string;
  thumbnailImageService?: string;
  useCustomThumbnail: boolean;
};

export type SettingsSpeaker = {
  firstName: string;
  lastName: string;
  fullName: string;
  title: string;
  bio: string;
  socialUrls: SettingsSocialUrls;
  headshotPath: string;
};

export type SettingsSocialUrls = {
  twitter: string;
  linkedin: string;
  website: string;
};

export type SettingsData = {
  id: string;
  title: string;
  description: string;
  unauthenticatedAccessAllowed: boolean;
  cardDetails: CardDetailsInput;
  speaker: SettingsSpeaker;
  publishState: PublishState;
  useGiideTones: boolean;
  noindex?: boolean | null;
};

export type ImageValidatorResponseType = {
  isValid: boolean;
  error?: string;
};

export type Filters = {
  waiting: boolean;
  published: boolean;
  unpublished: boolean;
  migrating: boolean;
  transcoding: boolean;
  error: boolean;
  review: boolean;
  pending: boolean;
  public: boolean;
  private: boolean;
};

export type paginationValues = {
  minValue: number;
  maxValue: number;
};

export type giideListSort = {
  type: string;
  descending: boolean;
};

export type giideListPaginationPage = {
  page: number;
  paginationState: {
    minValue: number;
    maxValue: number;
  };
};

export type UserInvite = {
  email: string;
  giideId: string;
  isNew: boolean;
  isDeleted: boolean;
};

export type PreviewDetails = {
  loaded: boolean;
  loading: boolean;
};

export type ImageEditorPosition = {
  x: number;
  y: number;
};

export type ImageEditorState = {
  position: ImageEditorPosition;
  scale?: number;
};

export type ImageEditorProps = {
  image: string | null;
  fileName: string;
  handleUpload?: (
    file,
    firstUpload?: boolean,
    shouldUpload?: boolean
  ) => Promise<boolean> | Promise<{}>;
  handleRemove: () => void;
  editorRef?: AvatarEditor | null;
  setEditorRef: (editor: AvatarEditor | null) => void;
  uploadProgress?: number;
  updateThumbnail?;
  hideUploadIcon?: boolean;
  handleLoadImage: (file: File) => void;
  uploading?: boolean;
  disabled?: boolean;
  type?: string;
  loading?: boolean;
  imgWidth: number;
  imgHeight: number;
  imgBorderWidth: number;
  imgBorderHeight: number;
  imgBorderRadius: number;
  sliderWidth: number;
  removeTextClass?: string;
  avatarEditorClass?: string;
  boxSizeClass?: string;
  staticImageClass?: string;
  loadingBoxClass?: string;
  validationFailed?: boolean;
  disableEditor?: boolean;
  text?: ReactElement<any, any>;
  buttons?: ReactElement<any, any>;
  updateImageCardProps?: (
    file?,
    firstUpload?: boolean,
    shouldUpload?: boolean
  ) => void;
  minWidth?: number;
  minHeight?: number;
};

export type ImageEditorValidation = {
  failed: boolean;
  errorMessage?: string;
};

export type WindowDimensions = {
  width: number;
  height: number;
};

export type GiideAudioLibraryFetching = {
  fetching: boolean;
  refreshing: boolean;
};

export type UnlinkRecordingProps = {
  id: string;
  timestamp: string;
};

// export type Plan =
//   | GetPlanQuery['getPlan']
//   | (OnUpdateUserPlanTimeStampSubscription['onUpdateUserPlanTimeStamp'] & {
//       id: string;
//     });

export type Plan = GetPlanOutput;

export type giideTabState = 'audio' | 'transcript' | 'published' | undefined;

export type AudioLibOperationsHook = {
  audioLibOperations: AudioLibOperations;
  audioLibOperationsData: AudioLibOperationsData;
};

export type AudioLibOperations = {
  handleChangeAudio: () => void;
  handleNextClick: () => void;
  setSelectedId: React.Dispatch<React.SetStateAction<string | null>>;
  setShowChangeAudioModal: (showChangeAudioModal: boolean) => void;
  setQuery: (query: string | null) => void;
};

export type AudioLibOperationsData = {
  query: string | null;
  loading: boolean;
  changing: boolean;
  selectedId: string | null;
  showChangeAudioModal: boolean;
};

export type RecordingAudioState =
  | 'info'
  | 'countDown'
  | 'recording'
  | 'preview'
  | undefined;

export enum PaymentState {
  idle,
  processing,
  successful,
}

export enum CreateGiideErrorType {
  unknown,
  maximumReached,
}

export enum exportVideoModal {
  none,
  start,
  alreadyProcessingError,
  maxLengthExceededError,
  maxFeedCardsExceededError,
  loading,
}

export type ExportVideoState = {
  id?: string;
  title?: string;
  error?: boolean;
  status?: string;
  downloadLink?: string;
  modal?: exportVideoModal;
  requestedGiideId?: string;
  requestedGiideTitle?: string;
  progress?: number;
};
